import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useTranslation } from '~/Locale';
import { COLORS, GAME_TITLE } from '../constants';
import PlayButton from './PlayButton';

const bounce = keyframes`
  from { transform: translateY(0); }
  to { transform: translateY(-8px); }
`;

const CarEmoji = styled.div`
  font-size: 48px;
  animation: ${bounce} 1s ease-in-out infinite alternate;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: ${COLORS.yellow};
  text-align: center;
  line-height: 1.1;
  margin: 0;
`;

const Intro = styled.p`
  font-size: 14px;
  color: #bbb;
  text-align: center;
  max-width: 300px;
  line-height: 1.6;

  .highlight {
    color: ${COLORS.teal};
    font-weight: 700;
  }
`;

const Legend = styled.div`
  display: flex;
  gap: 12px;
`;

const DealBadge = styled.span`
  background: ${COLORS.teal};
  color: #fff;
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 12px;
  font-weight: 700;
`;

const DangerBadge = styled(DealBadge)`
  background: ${COLORS.coral};
`;

export interface StartOverlayProps {
  onStart: () => void;
}

const StartOverlay = ({ onStart }: StartOverlayProps) => {
  const { t } = useTranslation();

  return (
    <>
      <CarEmoji>🚗</CarEmoji>
      <Title>{GAME_TITLE}</Title>
      <Intro>
        {t('Collect as many')}{' '}
        <span className="highlight">{t('golden stars')}</span>{' '}
        {t('as you can and dodge the obstacles!')}
      </Intro>
      <Legend>
        <DealBadge>{t('★ Star +50p')}</DealBadge>
        <DangerBadge>{t('● Crash −1 life')}</DangerBadge>
      </Legend>
      <PlayButton type="button" onClick={onStart}>
        {t('Start race')}
      </PlayButton>
    </>
  );
};

export default StartOverlay;
